const SetItemInLocalStorage = (item, value) => {
  try {
    localStorage.setItem(item, JSON.stringify(value));
  } catch (err) {
    console.error(`Error setting item "${item}" in localStorage:`, err);
  }
};

export default SetItemInLocalStorage;
